import React from 'react';
import { Alert, Button } from 'react-bootstrap';

export const AlertElement = ({ textBody, clickHandler }) => {

  let linkText = "";
  let textBody2 = "";

  let ndx = (textBody.indexOf("<link>"));

  if (ndx >= 0) {
    let ndx1 = (textBody.indexOf("</link>"));
    linkText = textBody.substring(ndx + 6, ndx1);
    textBody2 = textBody.substring(ndx1 + 7);
    textBody = textBody.substring(0, ndx);
  }


  return(
    <div className='alert-wrapper'>
      <Alert varient="companies">
        <i className="fa fa-info-circle" aria-hidden="true" />
        {textBody}
        {linkText ? <Button className="remove-filter-link embedded" onClick={clickHandler}>{linkText}</Button> : null }
        {textBody2 ? textBody2 : null}
      </Alert>
    </div>
  )
};